import React from 'react';
import { theme } from '../../utils/theme';

const VideoManagement = ({ failedVideos, onRetryGeneration }) => {
    const tableStyles = {
        wrapper: `${theme.card.base} bg-opacity-5 overflow-hidden`,
        table: "min-w-full",
        header: "border-b border-[#6D9773]/20",
        headerCell: "px-6 py-3 text-left text-xs font-medium text-[#0C3B2E] uppercase tracking-wider",
        row: "border-b border-[#6D9773]/10 hover:bg-[#6D9773]/5 transition-colors",
        cell: "px-6 py-4 text-sm text-[#0C3B2E]"
    };

    return (
        <div className={tableStyles.wrapper}>
            <div className="overflow-x-auto">
                <table className={tableStyles.table}>
                    <thead className={tableStyles.header}>
                        <tr>
                            <th className={tableStyles.headerCell}>Content ID</th>
                            <th className={tableStyles.headerCell}>Status</th>
                            <th className={tableStyles.headerCell}>Retry Count</th>
                            <th className={tableStyles.headerCell}>Last Retry</th>
                            <th className={tableStyles.headerCell}>Photo URL</th>
                            <th className={tableStyles.headerCell}>Error</th>
                            <th className={tableStyles.headerCell}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {failedVideos.map(video => (
                            <tr key={video.id} className={tableStyles.row}>
                                <td className={tableStyles.cell}>{video.id}</td>
                                <td className={tableStyles.cell}>
                                    <span className={`px-2 py-1 rounded-full text-xs font-medium border ${
                                        video.status === 'retry_pending' 
                                            ? 'bg-yellow-100 text-yellow-800 border-yellow-200'
                                            : 'bg-red-100 text-red-800 border-red-200'
                                    }`}>
                                        {video.status === 'retry_pending' ? 'Retry Pending' : 'Failed'}
                                    </span>
                                </td>
                                <td className={tableStyles.cell}>{video.retryCount || 0}</td>
                                <td className={tableStyles.cell}>
                                    {video.lastRetryAt ? new Date(video.lastRetryAt).toLocaleString() : 'Never'}
                                </td>
                                <td className={tableStyles.cell}>{video.photoUrl}</td>
                                <td className={tableStyles.cell}>{video.ErrorLogs[0]?.errorMessage}</td>
                                <td className={tableStyles.cell}>
                                    <div className="flex gap-2">
                                        <button 
                                            onClick={() => onRetryGeneration(video.id)}
                                            className={`${theme.button.base} ${theme.button.secondary} ${theme.button.sizes.sm}`}
                                            disabled={video.status === 'retry_pending'}
                                            title={video.status === 'retry_pending' ? 'Already queued for retry' : 'Retry generation'}
                                        >
                                            {video.status === 'retry_pending' ? 'Queued' : 'Retry Now'}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default VideoManagement;